var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "../Button/Button";
import CollapseButton from "./CollapseButton";
var CardHeader = function (_a) {
    var title = _a.title, action = _a.action, collapsableButton = _a.collapsableButton;
    var titleEl = (_jsx("div", __assign({ className: "ml-4 mt-2" }, { children: _jsx("h3", __assign({ className: "text-lg font-bold leading-6 text-gray-900" }, { children: title })) })));
    var titleWrapper = collapsableButton
        ? _jsx("button", __assign({ onClick: function () { return collapsableButton.setCollapsed(!collapsableButton.collapsed); } }, { children: titleEl }))
        : _jsx(_Fragment, { children: titleEl });
    return (_jsx("div", __assign({ className: "bg-white px-4 py-5 sm:px-6" }, { children: _jsxs("div", __assign({ className: "-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap" }, { children: [titleWrapper, _jsxs("div", __assign({ className: "ml-4 mt-2 flex-shrink-0 flex flex-row items-center gap-3" }, { children: [action && _jsx(Button, __assign({}, action)), collapsableButton && _jsx(CollapseButton, __assign({}, collapsableButton))] }))] })) })));
};
export default CardHeader;
